import React, { Component } from "react";
import _ from "lodash";
import AppBar from "material-ui/AppBar";
import { connect } from "react-redux";
import * as actions from "../actions/restaurants.actions";
import ProgressIndicator from "../components/ProgressIndicator";
import { browserHistory, withRouter, Link } from "react-router";
import UserIcon from "material-ui/svg-icons/action/account-circle";
import SelectField from "material-ui/SelectField";
import Popover from "material-ui/Popover";
import FlatButton from "material-ui/FlatButton";
import { Menu, MenuItem } from "material-ui/Menu";
import firebase from "../firebase";
import PropTypes from "prop-types";
import { DropDownMenu } from "material-ui";
import Avatar from "material-ui/Avatar/Avatar";
import logo from "../images/chowreach_logo.png";
import { isMobile } from "react-device-detect";

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopOver: false,
      restaurants: null,
    };
  }

  handleTouchTap = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleLogout = () => {
    firebase.auth().signOut();
    this.handleRequestClose();
  };

  isLoggedIn = () => !!firebase.auth().currentUser;

  getUserEmail = () => {
    if (firebase.auth().currentUser) {
      return firebase.auth().currentUser.email;
    }
    return "";
  };

  handleSupport = () => {
    window.open("mailto:hello@chowreach.com", "_blank");
    this.handleRequestClose();
  };

  componentDidMount() {
    this.unsubscribeAuthListener = firebase
      .auth()
      .onAuthStateChanged(async (user) => {
        if (!user) {
          console.log("No user");
          return;
        }

        try {
          const snaps = await firebase
            .firestore()
            .collection("restaurant")
            .where(`staff.${user.uid}`, "==", true)
            .get();

          const restaurants = {};
          snaps.forEach((doc) => {
            restaurants[doc.id] = doc.data();
          });
          console.log({ restaurants });

          this.setState({
            restaurants,
          });
        } catch (e) {
          console.log({ e });
        }
      });
  }

  componentWillUnmount() {
    this.unsubscribeAuthListener && this.unsubscribeAuthListener();
  }

  render() {
    const { title, hideDrawer } = this.props;

    return (
      <div className="TopBar">
        <AppBar
          style={{ position: "fixed", top: 0, left: 0, display: "flex" }}
          title={this.renderTitle()}
          titleStyle={{ display: "flex" }}
          showMenuIconButton={!hideDrawer}
          onLeftIconButtonClick={this.props.handleDrawerTap}
          iconElementRight={
            <FlatButton label={this.getUserEmail()} icon={<UserIcon />} />
          }
          onRightIconButtonClick={this.handleTouchTap}
        />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          targetOrigin={{ horizontal: "left", vertical: "top" }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>
            <MenuItem
              primaryText="Help &amp; feedback"
              onClick={this.handleSupport}
            />
            {this.isLoggedIn() ? (
              <MenuItem primaryText="Sign out" onClick={this.handleLogout} />
            ) : (
              ""
            )}
          </Menu>
        </Popover>
      </div>
    );
  }

  handleRestaurantClick = (restaurantId) => {
    window.location.href = `/${restaurantId}`;
  };

  renderTitle() {
    const { isMobile } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "center",
          justifyContent: isMobile ? "space-between" : "flex-start",
        }}
      >
        <Link to="/">
          <img src={logo} />
        </Link>
        {this.renderRestaurants()}
      </div>
    );
  }

  renderRestaurants() {
    const { restaurantId } = this.props;
    const { restaurants } = this.state;

    if (!this.isLoggedIn() || !restaurants || _.isEmpty(restaurants))
      return <div />;

    return (
      <DropDownMenu labelStyle={{ color: "white" }} value={restaurantId}>
        <MenuItem disabled value={0} primaryText="Select restaurant..." />
        {_.map(restaurants, (restaurant, key) => (
          <MenuItem
            key={key}
            value={key}
            primaryText={restaurant.name}
            onClick={() => this.handleRestaurantClick(key)}
          />
        ))}
      </DropDownMenu>
    );
  }
}

TopBar.propTypes = {
  handleDrawerTap: PropTypes.func,
  title: PropTypes.string,
  hideDrawer: PropTypes.bool,
};

TopBar.defaultProps = {
  handleDrawerTap: () => {},
  restaurantId: 0,
  title: "",
  hideDrawer: false,
};

function mapStateToProps(state) {
  return {
    restaurants: state.restaurants.restaurantList,
    isLoading: state.restaurants.loading,
  };
}

export default connect(mapStateToProps, actions)(withRouter(TopBar));



// WEBPACK FOOTER //
// ./src/components/TopBar.jsx